/* eslint-disable @typescript-eslint/no-throw-literal */
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { IAnatomopathologicalTest, IFetchAnatomopathologicalTest } from '~/interfaces'
import { fetchAnatomopathologicalTest, message } from '~/services'
import { hasObjectValue } from '~/utils'
import { AxiosError } from '~/modules'

const UNIQUE_KEY = 'anatomopathologicalTest'

export const useFetchAnatomopathologicalTest = (
  fetchParams: IFetchAnatomopathologicalTest | null,
  config?: UseQueryOptions<IAnatomopathologicalTest, Error, IAnatomopathologicalTest>
): UseQueryResult<IAnatomopathologicalTest, Error> => {
  const hasFetchParams = hasObjectValue({ ...fetchParams })

  const fetcher = async () => {
    if (!fetchParams) throw new Error('fetchParams is required')

    try {
      const response = await fetchAnatomopathologicalTest(fetchParams)
      const isResponseEmpty = !hasObjectValue({ ...response })

      if (isResponseEmpty) {
        throw message('detailsMedicalEvents.emptyResponseFetched')
      }

      return response
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError?.code === '404') {
        throw new Error(message('detailsMedicalEvents.emptyResponseFetched'))
      }
      if (typeof error === 'string') throw new Error(error)
      throw new Error(message('messages.genericUnexpectedError'))
    }
  }

  return useQuery<IAnatomopathologicalTest, Error>([UNIQUE_KEY, fetchParams?.pathParams], fetcher, {
    cacheTime: Infinity,
    staleTime: Infinity,
    enabled: hasFetchParams,
    ...config
  })
}
